export default {
	state: {
		score: 0,
	},
	actions: {
		updateScore(context) {
			const scoreValues = context.rootState.config.general.score_multipliers;
			let newPoints = 0;

			newPoints += scoreValues.fed_cats * context.rootState.cycle.actions.satisfied;
			newPoints += scoreValues.hungry_cats * context.rootState.cycle.actions.unsatisfied;
			newPoints -= scoreValues.dead_cats * context.rootState.cycle.actions.killed;
			newPoints += Math.floor(context.rootState.cycle.completedPercentage * 100);

			context.commit("incrementScore", {
				amount: newPoints,
			});
		},
	},
	mutations: {
		incrementScore(state, payload) {
			state.score += payload.amount;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/score.js